import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { DoctorRequestDetail } from '../../shared/models/request-doctor-detail.model';

interface DoctorRequestPayload {
  requestID: number;
  serviceStart?: string;
  serviceDuration?: string;
  requiredLanguageByte?: string;
  requiredLanguage?: string[];
  requestDescription?: string;
  netHourCost?: number;
  packageFlatCost?: number;
  updatedAt?: string;
  hoursAmount?: number;
  trial: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class RequestDoctorService {
  private baseURL = environment.baseURL;

  constructor(private http: HttpClient) {}

  private toPayload(requestID: number, detail: DoctorRequestDetail): DoctorRequestPayload {
    return {
      requestID,
      serviceStart: detail.serviceStart,
      serviceDuration: detail.serviceDuration,
      requiredLanguageByte: detail.requiredLanguageByte,
      requiredLanguage: detail.requiredLanguage,
      requestDescription: detail.requestDescription,
      netHourCost: detail.netHourCost,
      packageFlatCost: detail.packageFlatCost,
      updatedAt: detail.updatedAt,
      hoursAmount: detail.hoursAmount,
      trial: detail.trial,
    };
  }

  getVideoConsultationDetail(requestID: number) {
    return this.http.get<DoctorRequestDetail>(`${this.baseURL}/video-consultation-request/${requestID}`);
  }

  saveVideoConsultationDetail(requestID: number, detail: DoctorRequestDetail) {
    return this.http.post<DoctorRequestDetail>(`${this.baseURL}/video-consultation-request`, this.toPayload(requestID, detail));
  }

  getInPersonDetail(requestID: number) {
    return this.http.get<DoctorRequestDetail>(`${this.baseURL}/in-person-consultation-request/${requestID}`);
  }

  saveInPersonDetail(requestID: number, detail: DoctorRequestDetail) {
    return this.http.post<DoctorRequestDetail>(`${this.baseURL}/in-person-consultation-request`, this.toPayload(requestID, detail));
  }
}
